export const getTvTimeframe = (time) => {
    switch (time) {
        case '6M':
            return '6M';
        case '1Y':
            return '12M';
        default:
            return '3M';
    }
}